import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, Media, Tooltip } from "@opensea/ui-kit";
import { Add, ArrowDownward, Send, SwapCalls } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../../../components/Button";
import { useIsAbstractWalletAccount } from "../../../../../hooks/useIsAbstractWalletAccount";
import { useChainArch } from "../../../../../polychain/hooks";
import { useFlag } from "../../../../../providers/FlagProvider/useFlag";
import { FlowActions, FlowState } from "../../../../../stores/flowStore";
import { useDepositFlow } from "../../../../hooks/useDepositFlow";
import { useSendFlow } from "../../../../hooks/useSendFlow";
import { useSwapFlow } from "../../../../hooks/useSwapFlow";
import { useTopupFlow } from "../../../../hooks/useTopupFlow";
export function CryptoTabActions() {
  const $ = _c(46);
  const t = useTranslations("wallet.CryptoTabActions");
  const {
    flow
  } = useSnapshot(FlowState);
  const sendFlow = useSendFlow();
  const swapFlow = useSwapFlow();
  const depositFlow = useDepositFlow();
  const topupFlow = useTopupFlow();
  const isAbstractWallet = useIsAbstractWalletAccount();
  let t0;
  if ($[0] !== flow) {
    t0 = () => {
      if (flow) {
        FlowActions.startFlow(flow);
      }
    };
    $[0] = flow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onBack = t0;
  const chainArch = useChainArch();
  const solanaTokenSendEnabled = useFlag("solanaTokenSendEnabled");
  const isSendEnabled = chainArch === "EVM" || chainArch === "SVM" && solanaTokenSendEnabled;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Send />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isSendEnabled || $[4] !== onBack || $[5] !== sendFlow) {
    t2 = isSendEnabled ? () => sendFlow({
      onBack
    }) : undefined;
    $[3] = isSendEnabled;
    $[4] = onBack;
    $[5] = sendFlow;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("send");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <ActionButton icon={t1} onClick={t2} title={t3} />;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SwapCalls />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== onBack || $[14] !== swapFlow) {
    t6 = () => swapFlow({
      onBack
    });
    $[13] = onBack;
    $[14] = swapFlow;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("swap");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <ActionButton icon={t5} onClick={t6} title={t7} />;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ArrowDownward />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== depositFlow || $[23] !== onBack) {
    t10 = () => depositFlow({
      onBack
    });
    $[22] = depositFlow;
    $[23] = onBack;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("deposit");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <ActionButton icon={t9} onClick={t10} title={t11} />;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Add />;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== isAbstractWallet || $[32] !== onBack || $[33] !== topupFlow) {
    t14 = isAbstractWallet ? undefined : () => topupFlow({
      onBack
    });
    $[31] = isAbstractWallet;
    $[32] = onBack;
    $[33] = topupFlow;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t) {
    t15 = t("buy");
    $[35] = t;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== isAbstractWallet || $[38] !== t14 || $[39] !== t15) {
    t16 = <ActionButton disabled={isAbstractWallet} icon={t13} onClick={t14} title={t15} />;
    $[37] = isAbstractWallet;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t12 || $[42] !== t16 || $[43] !== t4 || $[44] !== t8) {
    t17 = <Flex className="justify-between gap-3">{t4}{t8}{t12}{t16}</Flex>;
    $[41] = t12;
    $[42] = t16;
    $[43] = t4;
    $[44] = t8;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}
function ActionButton(t0) {
  const $ = _c(36);
  const {
    title,
    icon,
    onClick,
    disabled
  } = t0;
  const t = useTranslations("wallet.CryptoTabActions");
  const isAbstractWallet = useIsAbstractWalletAccount();
  let t1;
  if ($[0] !== disabled || $[1] !== isAbstractWallet || $[2] !== t || $[3] !== title) {
    t1 = () => {
      if (disabled && isAbstractWallet && title === t("buy")) {
        return t("abstractWalletBuyNotAllowed");
      }
      return t("comingSoon");
    };
    $[0] = disabled;
    $[1] = isAbstractWallet;
    $[2] = t;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getTooltipContent = t1;
  let t2;
  if ($[5] !== getTooltipContent) {
    t2 = getTooltipContent();
    $[5] = getTooltipContent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = Boolean(onClick);
  const t4 = !onClick || disabled;
  let t5;
  if ($[7] !== icon) {
    t5 = <FlexColumn className="gap-3">{icon}</FlexColumn>;
    $[7] = icon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClick || $[10] !== t4 || $[11] !== t5) {
    t6 = <Button className="h-20 w-[80px] flex-1 basis-[100px] justify-center rounded-xl p-3 sm:w-[calc(23vw-8px)]" disabled={t4} onClick={onClick} variant="secondary">{t5}</Button>;
    $[9] = onClick;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== title) {
    t7 = <Flex className="justify-center pt-2 text-sm">{title}</Flex>;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Media lessThan="lg">{t6}{t7}</Media>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = !onClick || disabled;
  let t10;
  if ($[18] !== icon) {
    t10 = <Flex>{icon}</Flex>;
    $[18] = icon;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== title) {
    t11 = <Flex>{title}</Flex>;
    $[20] = title;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <FlexColumn className="gap-3">{t10}{t11}</FlexColumn>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== onClick || $[26] !== t12 || $[27] !== t9) {
    t13 = <Media greaterThanOrEqual="lg"><Button className="h-20 w-[94px] flex-1 basis-[100px] justify-start rounded-lg p-3" disabled={t9} onClick={onClick} variant="secondary">{t12}</Button></Media>;
    $[25] = onClick;
    $[26] = t12;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t8) {
    t14 = <div>{t8}{t13}</div>;
    $[29] = t13;
    $[30] = t8;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t2 || $[34] !== t3) {
    t15 = <Tooltip content={t2} disabled={t3}>{t14}</Tooltip>;
    $[32] = t14;
    $[33] = t2;
    $[34] = t3;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}